const sortDataByNumber = (data, key) => {
  let sortedData = data.slice().sort((a, b) => {
    let aData = a[key];
    let bData = b[key];
    return aData - bData;
  });
  return sortedData;
};
export default sortDataByNumber;
